import { createHaper } from 'haper';

export const haper = createHaper({
    //@ts-ignore
    baseUrl: window.appConfig.API_URL
});
